// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Esign_MainContainer__J-Nnq {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: clamp(20px, 5vw, 50px);
    box-sizing: border-box;
    min-height: 100vh;
    background: linear-gradient(to bottom right, #fff5f5, #fff);
    position: relative;
}

.Esign_MainWrapper__BFEmq {
    border: 1px solid #ffaeae;
    border-radius: 20px;
    background-color: #fff;
    box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);
    width: 90%;
    max-width: 800px;
    margin: 0 auto;
    padding: clamp(20px, 3vw, 30px);
    transition: all 0.3s ease;
}

.Esign_TopSection__VjmpW {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    border-bottom: 1px solid #e4e4e4;
    padding: 15px 20px;
}

.Esign_TopLeft__E2n9d {
    display: flex;
    align-items: center;
    gap: 15px;
}

.Esign_TopIcon__ZYRa5 {
    width: 40px;
    height: 40px;
}

.Esign_TopText__0SK3- {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #363636;
    margin: 0;
}

.Esign_SubText__r30ig {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 16px;
    color: #040404CC;
    text-align: center;
    margin: 20px 0;
}

.Esign_ContentWrapper__XAU0R {
    display: flex;
    justify-content: center;
    padding: 20px;
    flex-direction: column;
    gap: 20px;
}

.Esign_InfoCard__gJtCO {
    background: #f8f9fa;
    border: 1px solid #ffaeae;
    border-radius: 16px;
    padding: clamp(20px, 3vw, 30px);
    text-align: center;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    margin: 0 auto;
}

.Esign_InfoCard__gJtCO:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.Esign_CardTitle__2ZL7\\+ {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 20px;
    color: #333;
    margin: 0 0 15px 0;
}

.Esign_CardDescription__s0whP {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 14px;
    color: #404040BF;
    margin: 0 0 25px 0;
    line-height: 1.5;
}

.Esign_SignButton__u8zSR,
.Esign_RetryButton__z5cn2 {
    background-image: linear-gradient(45deg, #f73439, #f8777b);
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    padding: 12px 30px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);
    width: 100%;
    max-width: 300px;
}

.Esign_SignButton__u8zSR:hover,
.Esign_RetryButton__z5cn2:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);
    background-image: linear-gradient(45deg, #f8777b, #f73439);
}

.Esign_SignButton__u8zSR:active,
.Esign_RetryButton__z5cn2:active {
    transform: translateY(0);
    box-shadow: 0 2px 10px rgba(247, 52, 57, 0.2);
}

.Esign_LoaderModal__hLg2d {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.Esign_LoaderContent__R0ECf {
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.Esign_LoaderSpinner__Ailqh {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #f73439;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: Esign_spin__gKb8f 1s linear infinite;
}

@keyframes Esign_spin__gKb8f {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.Esign_LoaderText__Z71nl {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 16px;
    color: #333;
    margin-top: 15px;
}

.Esign_errorToast__cjqZ8 {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #f73439;
    color: white;
    padding: 12px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    animation: Esign_slideIn__rETdR 0.3s ease-out, Esign_fadeOut__RWPlK 0.3s ease-in 2.7s;
}

@keyframes Esign_slideIn__rETdR {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
}

@keyframes Esign_fadeOut__RWPlK {
    from { opacity: 1; }
    to { opacity: 0; }
}

.Esign_StepsContainer__MX9xD {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.Esign_StepCard__MkwvL {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    transition: all 0.3s ease;
    flex: 1 1; /* Changed from width: 100% to flex: 1 */
    min-width: 300px;
    box-sizing: border-box;
}

.Esign_StepCard__MkwvL.Esign_active__biTVJ {
    border-color: #f73439;
    box-shadow: 0 4px 12px rgba(247, 52, 57, 0.1);
}

.Esign_StepCard__MkwvL.Esign_completed__gX1s0 {
    border-color: #28a745;
    background-color: #f8fff9;
}

.Esign_StepHeader__WTHNI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.Esign_StepTitle__Jtwxg {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.Esign_StepStatus__o6cbd {
    font-family: 'CircularXXWeb-Medium', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 12px;
    border-radius: 20px;
}

.Esign_StepStatus__o6cbd.Esign_pending__eDJ12 {
    background-color: #fff5f5;
    color: #f73439;
}

.Esign_StepStatus__o6cbd.Esign_completed__gX1s0 {
    background-color: #e6fffa;
    color: #28a745;
}

.Esign_StepActions__c23oj {
    display: flex;
    gap: 15px;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
}

.Esign_DownloadButton__wC2Ql {
    background-color: #fff;
    border: 1px solid #333;
    color: #333;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: 'CircularXXWeb-Medium', sans-serif;
}

.Esign_DownloadButton__wC2Ql:hover {
    background-color: #f5f5f5;
}

.Esign_EditButton__II6g1 {
    background-color: transparent;
    border: 1px solid #007bff;
    color: #007bff;
    padding: 8px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
}

.Esign_LayoutContainer__DcuxL {
    display: flex;
    gap: 30px;
    margin-top: 30px;
    flex-wrap: wrap;
}

/* .LeftPanel and .RightPanel are no longer used but kept for reference or removed */
.Esign_LeftPanel__Ftw0o {
    flex: 1 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    display: none; /* Hidden as we moved to direct grid/flex layout */
}

.Esign_RightPanel__pGu5D {
    flex: 1 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    display: none; /* Hidden */
}

.Esign_ProgressBar__u0xAv {
    display: flex;
    align-items: flex-start; /* Changed from center to allow top alignment for line */
    justify-content: space-between;
    margin-bottom: 20px;
    position: relative;
    max-width: 500px; /* Increased width for better spacing */
    margin: 0 auto 30px;
    width: 100%;
}

.Esign_ProgressBar__u0xAv::before {
    content: '';
    position: absolute;
    top: 16px; /* Aligns with the center of the 32px circle */
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #e0e0e0;
    z-index: 1;
    transform: translateY(-50%);
}

.Esign_StepIndicator__Xu03m {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 2;
    background-color: #fff;
    padding: 0 10px;
}

.Esign_StepCircle__vmw9s {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #fff;
    border: 2px solid #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #666;
    transition: all 0.3s;
}

.Esign_StepCircle__vmw9s.Esign_active__biTVJ {
    border-color: #f73439;
    color: #f73439;
    background-color: #fff5f5;
}

.Esign_StepCircle__vmw9s.Esign_completed__gX1s0 {
    background-color: #28a745;
    border-color: #28a745;
    color: #fff;
}

.Esign_StepLabel__SBujb {
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

.Esign_StepLabel__SBujb.Esign_active__biTVJ {
    color: #f73439;
}

.Esign_StepLabel__SBujb.Esign_completed__gX1s0 {
    color: #28a745;
}

.Esign_SebiText__ZNITW {
    background-color: #fff8e1;
    border: 1px solid #ffe58f;
    padding: 15px;
    border-radius: 8px;
    font-size: 14px;
    color: #856404;
    line-height: 1.5;
    margin-bottom: 20px;
}

.Esign_DdpiContainer__gmJln {
    background-color: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px; /* Changed from margin-top to margin-bottom */
}

.Esign_DdpiCheckboxLabel__1BTdd {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    cursor: pointer;
    font-size: 15px;
    line-height: 1.5;
    color: #333;
}

.Esign_DdpiCheckbox__-ZvjD {
    margin-top: 4px;
    width: 18px;
    height: 18px;
    accent-color: #f73439;
    cursor: pointer;
}

.Esign_DdpiCheckboxLabelDisabled__TuG6Y {
    cursor: not-allowed;
    opacity: 0.7;
}

.Esign_DdpiCheckboxLabelDisabled__TuG6Y .Esign_DdpiCheckbox__-ZvjD {
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/Esign.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,+BAA+B;IAC/B,sBAAsB;IACtB,iBAAiB;IACjB,2DAA2D;IAC3D,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,gDAAgD;IAChD,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,0CAA0C;IAC1C,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,0DAA0D;IAC1D,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,6CAA6C;IAC7C,WAAW;IACX,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,6CAA6C;IAC7C,0DAA0D;AAC9D;;AAEA;;IAEI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,+CAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,qFAA2D;AAC/D;;AAEA;IACI,OAAO,2BAA2B,EAAE;IACpC,KAAK,wBAAwB,EAAE;AACnC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,SAAO,EAAE,wCAAwC;IACjD,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA,oFAAoF;AACpF;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa,EAAE,kDAAkD;AACrE;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa,EAAE,WAAW;AAC9B;;AAEA;IACI,aAAa;IACb,uBAAuB,EAAE,wDAAwD;IACjF,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB,EAAE,uCAAuC;IACzD,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,8CAA8C;IACzD,OAAO;IACP,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB,EAAE,6CAA6C;AACtE;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".MainContainer {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: clamp(20px, 5vw, 50px);\n    box-sizing: border-box;\n    min-height: 100vh;\n    background: linear-gradient(to bottom right, #fff5f5, #fff);\n    position: relative;\n}\n\n.MainWrapper {\n    border: 1px solid #ffaeae;\n    border-radius: 20px;\n    background-color: #fff;\n    box-shadow: 0 10px 25px rgba(129, 126, 126, 0.1);\n    width: 90%;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: clamp(20px, 3vw, 30px);\n    transition: all 0.3s ease;\n}\n\n.TopSection {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 15px;\n    border-bottom: 1px solid #e4e4e4;\n    padding: 15px 20px;\n}\n\n.TopLeft {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.TopIcon {\n    width: 40px;\n    height: 40px;\n}\n\n.TopText {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 24px;\n    font-weight: 500;\n    color: #363636;\n    margin: 0;\n}\n\n.SubText {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 16px;\n    color: #040404CC;\n    text-align: center;\n    margin: 20px 0;\n}\n\n.ContentWrapper {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.InfoCard {\n    background: #f8f9fa;\n    border: 1px solid #ffaeae;\n    border-radius: 16px;\n    padding: clamp(20px, 3vw, 30px);\n    text-align: center;\n    width: 100%;\n    max-width: 500px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    margin: 0 auto;\n}\n\n.InfoCard:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n.CardTitle {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 20px;\n    color: #333;\n    margin: 0 0 15px 0;\n}\n\n.CardDescription {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 14px;\n    color: #404040BF;\n    margin: 0 0 25px 0;\n    line-height: 1.5;\n}\n\n.SignButton,\n.RetryButton {\n    background-image: linear-gradient(45deg, #f73439, #f8777b);\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    color: #fff;\n    border-radius: 12px;\n    border: none;\n    cursor: pointer;\n    padding: 12px 30px;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 15px rgba(247, 52, 57, 0.2);\n    width: 100%;\n    max-width: 300px;\n}\n\n.SignButton:hover,\n.RetryButton:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(247, 52, 57, 0.3);\n    background-image: linear-gradient(45deg, #f8777b, #f73439);\n}\n\n.SignButton:active,\n.RetryButton:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 10px rgba(247, 52, 57, 0.2);\n}\n\n.LoaderModal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.LoaderContent {\n    background: #fff;\n    padding: 30px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.LoaderSpinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #f73439;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.LoaderText {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 16px;\n    color: #333;\n    margin-top: 15px;\n}\n\n.errorToast {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    background: #f73439;\n    color: white;\n    padding: 12px 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    animation: slideIn 0.3s ease-out, fadeOut 0.3s ease-in 2.7s;\n}\n\n@keyframes slideIn {\n    from { transform: translateX(100%); }\n    to { transform: translateX(0); }\n}\n\n@keyframes fadeOut {\n    from { opacity: 1; }\n    to { opacity: 0; }\n}\n\n.StepsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n}\n\n.StepCard {\n    background: #fff;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n    transition: all 0.3s ease;\n    flex: 1; /* Changed from width: 100% to flex: 1 */\n    min-width: 300px;\n    box-sizing: border-box;\n}\n\n.StepCard.active {\n    border-color: #f73439;\n    box-shadow: 0 4px 12px rgba(247, 52, 57, 0.1);\n}\n\n.StepCard.completed {\n    border-color: #28a745;\n    background-color: #f8fff9;\n}\n\n.StepHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.StepTitle {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    margin: 0;\n}\n\n.StepStatus {\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 4px 12px;\n    border-radius: 20px;\n}\n\n.StepStatus.pending {\n    background-color: #fff5f5;\n    color: #f73439;\n}\n\n.StepStatus.completed {\n    background-color: #e6fffa;\n    color: #28a745;\n}\n\n.StepActions {\n    display: flex;\n    gap: 15px;\n    width: 100%;\n    flex-wrap: wrap;\n    align-items: center;\n}\n\n.DownloadButton {\n    background-color: #fff;\n    border: 1px solid #333;\n    color: #333;\n    padding: 10px 20px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.2s;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'CircularXXWeb-Medium', sans-serif;\n}\n\n.DownloadButton:hover {\n    background-color: #f5f5f5;\n}\n\n.EditButton {\n    background-color: transparent;\n    border: 1px solid #007bff;\n    color: #007bff;\n    padding: 8px 20px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.LayoutContainer {\n    display: flex;\n    gap: 30px;\n    margin-top: 30px;\n    flex-wrap: wrap;\n}\n\n/* .LeftPanel and .RightPanel are no longer used but kept for reference or removed */\n.LeftPanel {\n    flex: 1;\n    min-width: 300px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    display: none; /* Hidden as we moved to direct grid/flex layout */\n}\n\n.RightPanel {\n    flex: 1;\n    min-width: 300px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    display: none; /* Hidden */\n}\n\n.ProgressBar {\n    display: flex;\n    align-items: flex-start; /* Changed from center to allow top alignment for line */\n    justify-content: space-between;\n    margin-bottom: 20px;\n    position: relative;\n    max-width: 500px; /* Increased width for better spacing */\n    margin: 0 auto 30px;\n    width: 100%;\n}\n\n.ProgressBar::before {\n    content: '';\n    position: absolute;\n    top: 16px; /* Aligns with the center of the 32px circle */\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: #e0e0e0;\n    z-index: 1;\n    transform: translateY(-50%);\n}\n\n.StepIndicator {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n    z-index: 2;\n    background-color: #fff;\n    padding: 0 10px;\n}\n\n.StepCircle {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background-color: #fff;\n    border: 2px solid #e0e0e0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    color: #666;\n    transition: all 0.3s;\n}\n\n.StepCircle.active {\n    border-color: #f73439;\n    color: #f73439;\n    background-color: #fff5f5;\n}\n\n.StepCircle.completed {\n    background-color: #28a745;\n    border-color: #28a745;\n    color: #fff;\n}\n\n.StepLabel {\n    font-size: 14px;\n    color: #666;\n    font-weight: 500;\n}\n\n.StepLabel.active {\n    color: #f73439;\n}\n\n.StepLabel.completed {\n    color: #28a745;\n}\n\n.SebiText {\n    background-color: #fff8e1;\n    border: 1px solid #ffe58f;\n    padding: 15px;\n    border-radius: 8px;\n    font-size: 14px;\n    color: #856404;\n    line-height: 1.5;\n    margin-bottom: 20px;\n}\n\n.DdpiContainer {\n    background-color: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 20px; /* Changed from margin-top to margin-bottom */\n}\n\n.DdpiCheckboxLabel {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    cursor: pointer;\n    font-size: 15px;\n    line-height: 1.5;\n    color: #333;\n}\n\n.DdpiCheckbox {\n    margin-top: 4px;\n    width: 18px;\n    height: 18px;\n    accent-color: #f73439;\n    cursor: pointer;\n}\n\n.DdpiCheckboxLabelDisabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n.DdpiCheckboxLabelDisabled .DdpiCheckbox {\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainContainer": `Esign_MainContainer__J-Nnq`,
	"MainWrapper": `Esign_MainWrapper__BFEmq`,
	"TopSection": `Esign_TopSection__VjmpW`,
	"TopLeft": `Esign_TopLeft__E2n9d`,
	"TopIcon": `Esign_TopIcon__ZYRa5`,
	"TopText": `Esign_TopText__0SK3-`,
	"SubText": `Esign_SubText__r30ig`,
	"ContentWrapper": `Esign_ContentWrapper__XAU0R`,
	"InfoCard": `Esign_InfoCard__gJtCO`,
	"CardTitle": `Esign_CardTitle__2ZL7+`,
	"CardDescription": `Esign_CardDescription__s0whP`,
	"SignButton": `Esign_SignButton__u8zSR`,
	"RetryButton": `Esign_RetryButton__z5cn2`,
	"LoaderModal": `Esign_LoaderModal__hLg2d`,
	"LoaderContent": `Esign_LoaderContent__R0ECf`,
	"LoaderSpinner": `Esign_LoaderSpinner__Ailqh`,
	"spin": `Esign_spin__gKb8f`,
	"LoaderText": `Esign_LoaderText__Z71nl`,
	"errorToast": `Esign_errorToast__cjqZ8`,
	"slideIn": `Esign_slideIn__rETdR`,
	"fadeOut": `Esign_fadeOut__RWPlK`,
	"StepsContainer": `Esign_StepsContainer__MX9xD`,
	"StepCard": `Esign_StepCard__MkwvL`,
	"active": `Esign_active__biTVJ`,
	"completed": `Esign_completed__gX1s0`,
	"StepHeader": `Esign_StepHeader__WTHNI`,
	"StepTitle": `Esign_StepTitle__Jtwxg`,
	"StepStatus": `Esign_StepStatus__o6cbd`,
	"pending": `Esign_pending__eDJ12`,
	"StepActions": `Esign_StepActions__c23oj`,
	"DownloadButton": `Esign_DownloadButton__wC2Ql`,
	"EditButton": `Esign_EditButton__II6g1`,
	"LayoutContainer": `Esign_LayoutContainer__DcuxL`,
	"LeftPanel": `Esign_LeftPanel__Ftw0o`,
	"RightPanel": `Esign_RightPanel__pGu5D`,
	"ProgressBar": `Esign_ProgressBar__u0xAv`,
	"StepIndicator": `Esign_StepIndicator__Xu03m`,
	"StepCircle": `Esign_StepCircle__vmw9s`,
	"StepLabel": `Esign_StepLabel__SBujb`,
	"SebiText": `Esign_SebiText__ZNITW`,
	"DdpiContainer": `Esign_DdpiContainer__gmJln`,
	"DdpiCheckboxLabel": `Esign_DdpiCheckboxLabel__1BTdd`,
	"DdpiCheckbox": `Esign_DdpiCheckbox__-ZvjD`,
	"DdpiCheckboxLabelDisabled": `Esign_DdpiCheckboxLabelDisabled__TuG6Y`
};
export default ___CSS_LOADER_EXPORT___;
